angular.module('ecrd.states')

    .factory('EntityMenuPluginFormStates', [
        'CrfService',
        'FormStatesService',
        'RecordDataService',
        'FormFieldsService',
        function(CrfService, FormStatesService, RecordDataService, FormFieldsService) {
            var allStates = FormStatesService.getAvailableStates();

            function getFormStatesInfo(formId, listIndices) {
                var enabledStates = FormStatesService.getEnabledStates(formId, listIndices);

                var statesInfo = {};

                angular.forEach(allStates, function(stateInfo, stateId) {
                    statesInfo[stateId] = angular.isDefined(enabledStates[stateId]);
                });

                return statesInfo;
            }

            function getSectionStatesInfo(section, listIndices) {
                var statesInfo = {
                    total: 0, // Nº total de formularios
                };

                angular.forEach(section.getChildren(), function(child) {
                    var childInfo = {};
                    var childId = child.getId();

                    if (!FormFieldsService.isElementVisible(childId, listIndices) ||
                        !CrfService.isElementAvailableToCurrentProfile(childId)) {
                        return;
                    }

                    if (child.isForm()) {
                        childInfo = getFormStatesInfo(childId, listIndices);
                        childInfo.total = 1; // los formularios son finales, no pueden contener otros
                    } else if (child.isSection()) {
                        childInfo = getSectionStatesInfo(child, listIndices);
                    } else if (child.isList()) {
                        childInfo = getListStatesInfo(child, listIndices);
                    }

                    for (var stateId in childInfo) { // incluye la clave 'total' para sumarla también
                        if (angular.isUndefined(statesInfo[stateId])) {
                            statesInfo[stateId] = 0;
                        }
                        // Suma el contador del hijo:
                        // a) Si es final (Form), el valor de cada hijo puede ser true = 1, false = 0
                        // b) Si es un contenedor, se sumará el valor numérico de cada hijo
                        // c) Por último, si es el 'total', sumará directamente el valor numérico
                        statesInfo[stateId] += childInfo[stateId];
                    }
                });

                return statesInfo;
            }

            function getListStatesInfo(list, listIndices) {
                var statesInfo = {
                    total: 0,
                };

                var listData = RecordDataService.getList(list.getId(), listIndices);
                if (!angular.isArray(listData) || listData.length === 0) {
                    return statesInfo;
                }

                listIndices = listIndices || {};

                angular.forEach(listData, function(itemData, index) {
                    var itemIndices = angular.copy(listIndices);
                    itemIndices[list.getId()] = index + 1;

                    var itemInfo = getListItemStatesInfo(list, itemIndices);

                    for (var stateId in itemInfo) { // incluye la clave 'total' para sumarla también
                        if (angular.isUndefined(statesInfo[stateId])) {
                            statesInfo[stateId] = 0;
                        }
                        // Suma el contador del hijo:
                        // a) Si es final (Form), el valor de cada hijo puede ser true = 1, false = 0
                        // b) Si es un contenedor, se sumará el valor numérico de cada hijo
                        // c) Por último, si es el 'total', sumará directamente el valor numérico
                        statesInfo[stateId] += itemInfo[stateId];
                    }
                });

                return statesInfo;
            }

            function getListItemStatesInfo(list, listIndices) {
                var statesInfo = {
                    total: 0, // Nº total de formularios
                };

                // En un ítem de lista, solo usamos el recorrido de los descendientes directos
                // (es decir, que no estén contenidos a su vez en otra lista). De otro modo, los contaríamos 2 veces
                var listDescendants = list.getChildren().filter(function(child) {
                    return child.getParentList() === list;
                });

                angular.forEach(listDescendants, function(child) {
                    var childInfo = {};
                    var childId = child.getId();

                    if (!FormFieldsService.isElementVisible(childId, listIndices) ||
                        !CrfService.isElementAvailableToCurrentProfile(childId)) {
                        return;
                    }

                    if (child.isForm()) {
                        childInfo = getFormStatesInfo(childId, listIndices);
                        childInfo.total = 1; // los formularios son finales, no pueden contener otros
                    } else if (child.isSection()) {
                        childInfo = getSectionStatesInfo(child, listIndices);
                    } else if (child.isList()) {
                        childInfo = getListStatesInfo(child, listIndices);
                    }

                    for (var stateId in childInfo) { // incluye la clave 'total' para sumarla también
                        if (angular.isUndefined(statesInfo[stateId])) {
                            statesInfo[stateId] = 0;
                        }
                        // Suma el contador del hijo:
                        // a) Si es final (Form), el valor de cada hijo puede ser true = 1, false = 0
                        // b) Si es un contenedor, se sumará el valor numérico de cada hijo
                        // c) Por último, si es el 'total', sumará directamente el valor numérico
                        statesInfo[stateId] += childInfo[stateId];
                    }
                });

                return statesInfo;
            }

            return {
                initFormFlags: function(itemMetadata, elementId, entityData, stateParams) {
                    var listIndices = CrfService.getListIndices(stateParams);

                    itemMetadata.states = getFormStatesInfo(elementId, listIndices);
                },
                initSectionFlags: function(itemMetadata, elementId, entityData, stateParams) {
                    var section = 'element' in itemMetadata ? itemMetadata.element : CrfService.getSection(elementId);
                    var listIndices = CrfService.getListIndices(stateParams);

                    itemMetadata.states = section ? getSectionStatesInfo(section, listIndices) : {};
                },
                initListFlags: function(itemMetadata, elementId, entityData, stateParams) {
                    var list = 'element' in itemMetadata ? itemMetadata.element : CrfService.getList(elementId);
                    var listIndices = CrfService.getListIndices(stateParams);

                    itemMetadata.states = list ? getListStatesInfo(list, listIndices) : {};
                },
                initListItemFlags: function(itemMetadata, elementId, stateParams) {
                    var list = 'element' in itemMetadata ? itemMetadata.element : CrfService.getList(elementId);
                    var listIndices = CrfService.getListIndices(stateParams);

                    itemMetadata.states = list ? getListItemStatesInfo(list, listIndices, itemMetadata.id) : {};
                },
                reloadFlags: function(itemMetadata, elementId, elementType, sectionState, stateParams) {
                    var element = 'element' in itemMetadata ? itemMetadata.element : CrfService.getElement(elementId);
                    var listIndices = CrfService.getListIndices(stateParams);

                    if (itemMetadata.type === 'form') {
                        itemMetadata.states = getFormStatesInfo(elementId, listIndices);
                    } else if (itemMetadata.type === 'section') {
                        itemMetadata.states = getSectionStatesInfo(element, listIndices);
                    } else if (itemMetadata.type === 'list') {
                        itemMetadata.states = getListStatesInfo(element, listIndices);
                    }
                },
                reloadItemFlags: function(itemMetadata, itemState, stateParams, elementId) {
                    var element = 'element' in itemMetadata ? itemMetadata.element : CrfService.getElement(elementId);
                    var listIndices = CrfService.getListIndices(stateParams);

                    itemMetadata.states = getListItemStatesInfo(element, listIndices);
                },
                onElementFlagChangedVisibility: function(argumentsList) {
                    var itemMetadata = argumentsList[0];
                    // var elementId = argumentsList[1];
                    // var stateParams = argumentsList[2];
                    var listIndices = argumentsList[3].listIndices;

                    if (itemMetadata.type === 'form') {
                        itemMetadata.states = getFormStatesInfo(itemMetadata.element.getId(), listIndices);
                    } else if (itemMetadata.type === 'section') {
                        itemMetadata.states = getSectionStatesInfo(itemMetadata.element, listIndices);
                    } else if (itemMetadata.type === 'list') {
                        itemMetadata.states = getListStatesInfo(itemMetadata.element, listIndices);
                    } else if (itemMetadata.type === 'listItem') {
                        itemMetadata.states = getListItemStatesInfo(itemMetadata.element, listIndices);
                    }
                },
            };
        },
    ]);
